import { Link } from 'react-router-dom'

const DocumentViewBreadcrumbs = ({
    recordName,
    collectionName,
    collectionLink,
}) => {
    
    return (
        
        <div className="text-sm breadcrumbs">
            <ul>
                <li><Link to="/collections">Home</Link></li>
                <li><Link to={collectionLink}>{collectionName}</Link></li>
                <li>{recordName}</li>
            </ul>
        </div>
        
    )
    
}

export default DocumentViewBreadcrumbs
